import { createAction, props } from '@ngrx/store';
export const setSavedHypotheticalId = createAction('[Custom PDF Report Modal] Set Saved Hypothetical ID', props());
